interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const TableSeparatorIcon: React.FC<IconProps> = (props) => {
    return (
        <svg
            id="tableSeparator"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            {...props}
        >
            <rect id="Rectangle_4154" data-name="Rectangle 4154" width="16" height="16" fill="none" />
            <circle
                id="Ellipse_631"
                data-name="Ellipse 631"
                cx="1.5"
                cy="1.5"
                r="1.5"
                transform="translate(6.5 2.5)"
                fill="#dadee2"
            />
            <circle
                id="Ellipse_632"
                data-name="Ellipse 632"
                cx="1.5"
                cy="1.5"
                r="1.5"
                transform="translate(6.5 6.5)"
                fill="#dadee2"
            />
            <circle
                id="Ellipse_633"
                data-name="Ellipse 633"
                cx="1.5"
                cy="1.5"
                r="1.5"
                transform="translate(6.5 10.5)"
                fill="#dadee2"
            />
        </svg>
    );
};
